import React from 'react';
import { Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch, useSelector } from 'react-redux';

import { setState } from '../../../../redux/Slice/lopOvertimeRequestSlice';
import { useEditLopOvertimeRequestMutation } from '../../../../redux/apis/LOPAndOvertimeAPI';

import { getErrorMessage } from '../../../../utils/handler';
import { notification } from '../../../../utils/notification';
import { LB_HEADER } from '../../../../utils/constant/labels';
import { BT_BUTTON_LABELS } from '../../../../utils/constant/buttons';
import { LOP_AND_OVERTIME_STATUS } from '../../../../utils/constant/global';
import { lopOvertimeRequestRejectedSchema } from '../../../../utils/schemas/payrun';
import { ERROR_MESSAGE, TOAST_TYPE } from '../../../../utils/constant/errorMessage';
import './LopAndOvertimeRequestRejectedModel.scss';

const { BTN_REJECT } = BT_BUTTON_LABELS;
const { REJECTED } = LOP_AND_OVERTIME_STATUS;
const { TOAST_SUCCESS, TOAST_ERROR } = TOAST_TYPE;
const { LB_LOP_OVERTIME_REJECT, LB_ASK_LOP_OVERTIME_REJECT } = LB_HEADER;

const LopAndOvertimeRequestRejectedModel = () => {
  const dispatch = useDispatch();
  const lopOvertimeState = useSelector((state) => state.lopOvertimeRequest);

  const [editLopOvertimeRequest] = useEditLopOvertimeRequestMutation();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(lopOvertimeRequestRejectedSchema),
    defaultValues: {
      reason: ''
    }
  });

  const onSubmit = async (data) => {
    await handleUpdateLopOvertimeRequest(
      {
        status: REJECTED,
        statusReason: data.reason
      },
      lopOvertimeState?.isRejectedModel?.lopOvertimeId
    );
  };

  const handleUpdateLopOvertimeRequest = async (payload, id) => {
    try {
      if (!id) notification(ERROR_MESSAGE.ID_NOT_FOUND, TOAST_ERROR);

      dispatch(setState({ ...lopOvertimeState, loading: true }));

      const res = await editLopOvertimeRequest({ data: payload, id });
      if (res.data?.success) {
        notification(res?.data?.statusMessage, TOAST_SUCCESS);
      } else {
        notification(res?.data?.statusMessage, TOAST_ERROR);
      }
      onHandleCloseDialog();
    } catch (error) {
      onHandleCloseDialog();
      notification(error.message, TOAST_ERROR);
    }
  };

  const onHandleCloseDialog = () => {
    reset();
    dispatch(
      setState({ ...lopOvertimeState, isRejectedModel: { model: false, lopOvertimeId: '' } })
    );
  };

  return (
    <Modal
      centered
      className="lop-reject-modal"
      dialogClassName="lop-reject-modal__dialog"
      contentClassName="lop-reject-modal__content"
      show={lopOvertimeState?.isRejectedModel?.model ? true : false}
      onHide={() => {
        onHandleCloseDialog();
      }}
    >
      <Modal.Header className="lop-reject-modal__header">
        <div className="lop-reject-modal__header-content">
          <span className="lop-reject-modal__header-icon" aria-hidden="true">
            <i className="icofont-close-circled" />
          </span>
          <div className="lop-reject-modal__header-copy">
            <Modal.Title className="fw-bold lop-reject-modal__title" id="leaverejectLabel">
              {LB_LOP_OVERTIME_REJECT}
            </Modal.Title>
            <p className="lop-reject-modal__subtitle">{LB_ASK_LOP_OVERTIME_REJECT}</p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close lop-reject-modal__close"
          aria-label="Close"
          onClick={onHandleCloseDialog}
        />
      </Modal.Header>
      <form className="lop-reject-modal__form" onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body className="lop-reject-modal__body">
          <div className="lop-reject-modal__section">
            <label className="lop-reject-modal__label" htmlFor="lop-reject-reason">
              Reason
            </label>
            <textarea
              id="lop-reject-reason"
              rows={4}
              {...register('reason')}
              className={`form-control lop-reject-modal__textarea ${
                getErrorMessage('reason', errors) && 'is-invalid'
              }`}
              placeholder="Enter reason"
            />
            <small className="text-danger lop-reject-modal__error">
              {getErrorMessage('reason', errors)}
            </small>
          </div>
        </Modal.Body>
        <Modal.Footer className="lop-reject-modal__footer">
          <button type="submit" className="btn lop-reject-modal__submit">
            <i className="icofont-close-circled" aria-hidden="true" />
            {BTN_REJECT}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default LopAndOvertimeRequestRejectedModel;
